import {UIEvent, useRef} from "react";
import {useSelector} from "react-redux";
import {css, cx} from "@panda/css";

import {useScrollableListItemTracking} from "@pg-mono/hooks";

import {IRPStore} from "../../../app/rp_reducer";
import {RecommendOfferItem} from "../../../atoms/RecommendOfferItem";
import {notifyBugsnag} from "../../../errors/bugsnag/notify_bugsnag";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {ViewType} from "../../../view_type/ViewType";
import {hitMultileadRecommendationShown} from "../../tracking/lead/hit_multilead_recommendation_shown";
import {MultileadVersion} from "../../types/lead/MultileadVersion";
import {RecommendationSource} from "../../types/lead/RecommendationSource";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";

interface IProps {
    recommendedOffers: IRecommendedOffer[];
    isScrolledToBottom: boolean; // TODO: It looks like it's no longer in use, it needs to be deleted
    onListScroll: (event: UIEvent) => void;
    selected: number[];
    handleChange: (viewType: ViewType, recommendedItemID: number) => void;
    className?: string;
}

export function ApplicationMultiLeadSimpleRecommendationsOfferList(props: IProps) {
    const {recommendedOffers, onListScroll, selected} = props;

    const viewType = useSelector((store: IRPStore) => store.viewType.current);
    const listRef = useRef<HTMLUListElement>(null);

    useScrollableListItemTracking({
        scrollableListRef: listRef,
        listElementTrackingIdDatasetName: "trackId",
        handleListItemTrackingHit: (trackingId) => {
            hitMultileadRecommendationShown({
                recommendationId: trackingId,
                recommendationType: ApplicationMultiLeadRecommendationType.OFFER,
                recommendationSource: RecommendationSource.DISTANCE,
                multileadVersion: MultileadVersion.RP_LIST_OFFER,
                viewType
            });
        },
        onError: (error) => {
            console.warn(error);
            notifyBugsnag(new Error(error), error);
        }
    });

    return (
        <ul onScroll={onListScroll} ref={listRef} className={cx(listWrapperStyle, props.className)}>
            {recommendedOffers.map((recommendedItem) => {
                const offerID = recommendedItem.id;
                const isChecked = selected.includes(offerID);
                return (
                    <RecommendOfferItem
                        key={offerID}
                        data-track-id={offerID}
                        offer={recommendedItem}
                        checked={isChecked}
                        handleChange={() => props.handleChange(ViewType.OFFER, offerID)}
                    />
                );
            })}
        </ul>
    );
}

const listWrapperStyle = css({
    py: 1.5,
    px: 0,
    margin: 0,
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    maxHeight: "100%",
    listStyle: "none",
    position: "relative",
    md: {
        py: 3,
        px: 5,
        overflowY: "scroll",
        height: "440px",
        paddingRight: "7.5rem"
    }
});
